var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconFleet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89835 11.6608C6.78577 11.6608 0.572266 13.2112 0.572266 16.3238V16.6553H19.2244V16.3238C19.2244 13.2112 13.0109 11.6608 9.89835 11.6608ZM9.89835 9.32925C11.1351 9.32925 12.3211 8.83797 13.1956 7.96348C14.0701 7.08899 14.5614 5.90293 14.5614 4.66621C14.5614 3.4295 14.0701 2.24344 13.1956 1.36895C12.3211 0.494457 11.1351 0.00317383 9.89835 0.00317383C8.66163 0.00317383 7.47557 0.494457 6.60108 1.36895C5.72659 2.24344 5.23531 3.4295 5.23531 4.66621C5.23531 5.90293 5.72659 7.08899 6.60108 7.96348C7.47557 8.83797 8.66163 9.32925 9.89835 9.32925Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconFleet);
export default __webpack_public_path__ + "static/media/user_icon_fleet.c4b25893f3424f0b1bd97902207ca01e.svg";
export { ForwardRef as ReactComponent };